import { type FC } from "react";

import { Button, Modal, TextArea } from "@snapchat/snap-design-system";

import {
    feedbackRatingV1Container,
    feedbackRatingV1Header,
    feedbackRatingV1HeaderContainer,
    feedbackRatingV1Subheader,
    feedbackRatingV1TextArea,
} from "./FeedbackRatingV1.style";
import { Flexbox } from "./Flexbox.styles";
import { StarRating } from "./StarRating";
import { type FeedbackRating } from "./shared.types";

export const FeedbackRatingV1: FC<FeedbackRating> = ({
    onClose,
    onSubmit,
    onCommentTextChange,
    onRatingChange,
    commentText,
    rating,
}) => {
    return (
        <Modal
            visible
            footer={
                <Flexbox justifyContent="flex-end" gap="5%">
                    <Button onClick={onClose}>Close</Button>
                    <Button type="primary" onClick={onSubmit} isDisabled={!rating}>
                        Submit
                    </Button>
                </Flexbox>
            }
        >
            <div className={feedbackRatingV1Container}>
                <div className={feedbackRatingV1HeaderContainer}>
                    <div className={feedbackRatingV1Header}>Rate your experience</div>
                    <div className={feedbackRatingV1Subheader}>
                        Please help to improve My Lenses by providing your feedback.
                    </div>
                </div>
                <StarRating onClick={onRatingChange} label="Select rating" />
                <TextArea
                    label="Why did you choose this rating? (Optional)"
                    placeholder="Please type here"
                    className={feedbackRatingV1TextArea}
                    maxLength={200}
                    onChange={onCommentTextChange}
                    value={commentText}
                />
            </div>
        </Modal>
    );
};
